import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useStateValue } from "../../Middleware/context/StateBusinessProvider";
import "../../Css/CardAgendadetails.css";
import { useAuth } from "../../Middleware/context/AuthContext";



function CardAgendaDetails({
  
  imgAlt = [],
       fornecedor,
       nameProduto,
        id,
        tipo,
        price,
        img,
       description,
        idSupplier,
        size,
        destinoVenda,
       category,
       taxa,
       tipoArtigo,
  services = [],
  objs
}) {
  const navigate = useNavigate();
  const [mainImage, setMainImage] = useState(img || imgAlt?.[0]);
  const [quantity, setQuantity] = useState(1);
  const [service, setService] = useState("");
  const { dispatch } = useStateValue();
  const {user}=useAuth();


  const checkout=(user)=>{


if(!user){

    navigate("/UserErro");
}

else if (user){
 if (!service) return alert("Selecione um serviço");

         dispatch({
         type: "Agenda_Service",
        item: {
         fornecedor,
         taxa,
         nameProduto,
         id,
         tipo,
        price:(price*quantity)+(taxa*quantity),
         img: mainImage,
         quantity,
        tamanho: service,
         description,
         idSupplier,
         destinoVenda,
         category,
         status:"Pending",
        tipoArtigo:"Agenda",
       }
     });
      navigate('/Service/Checkout')
    }
  }


  return (
    <div className="agenda-details-page">
      <button className="agenda-details-back" onClick={() => navigate(-1)}>
        ← Voltar
      </button>

      <div className="agenda-details-container">
        {/* IMAGENS */}
        <div className="agenda-details-images">
          <img
            src={mainImage}
            alt={nameProduto}
            className="agenda-details-main-img"
          />

          <div className="agenda-details-thumbs">
            {imgAlt?.map((item, index) => (
              <img
                key={index}
                src={item}
                alt="thumb"
                className="agenda-details-thumb"
                onClick={() => setMainImage(item)}
              />
            ))}
          </div>
        </div>

        {/* INFORMAÇÕES */}
        <div className="agenda-details-info">
          <h1 className="agenda-details-title">{""}</h1>

          <span className="agenda-details-supplier">
            {tipo}: {fornecedor}
          </span>

          <span className="agenda-details-availability">
            Disponível para: {destinoVenda}
          </span>

          <label className="agenda-details-label">
            {"Escolhe o seu servico no"+category}
            <select
              className="agenda-details-select"
              value={service}
              onChange={(e) => setService(e.target.value)}
            >
              <option value="">Selecione</option>
              {size?.map((item, index) => (
                <option key={index} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </label>

          <p className="agenda-details-description">{description}</p>

          <span className="agenda-details-price">
           {(price * quantity)+(taxa*quantity)} Kz 
          </span>

          <div className="agenda-details-quantity">
            <button onClick={() => quantity > 1 && setQuantity(quantity - 1)}>
              −
            </button>
            <span>{quantity}</span>
            <button onClick={() => setQuantity(quantity + 1)}>+</button>
          </div>

          <button className="agenda-details-action" onClick={()=>{checkout(user)}}>
            Agendar
          </button>
        </div>
      </div>
    </div>
  );
}
export default CardAgendaDetails;
